<template>
  <div id="wrap" class="update_popup">
    <h1>KOLON</h1>
    <div class="update_cont">
      <div class="cont_group">
        <a :href="appUpdateUrl" class="dow_btn">
          <img class="app_icon" :src="appImg" v-if="appImg">
          <img src="@/assets/image/ico-app-h-72.png" v-else>
          <i><img src="@/assets/image/ico-app-down-h-32.png"></i>
          <span>{{ appNm }}</span>
        </a>
        <!-- <p>위 버튼을 클릭하시어<br>{{ appNm }}을 다운로드 후 업데이트를 완료해 주세요!</p> -->
        <p>위 버튼을 클릭하시어<br>{{ appNm }}을(를) 다운로드 후 업데이트를 완료해 주세요!</p>
        <!-- <p>위 버튼을 클릭하시어<br>앱을 다운로드 후 업데이트를 완료해 주세요!</p> -->
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios"

export default {
  name: 'Update',
  data(){
    return {
      appId: '',
      appNm: '',
      appOs: '',
      appVerId: '',
      userAccount: '',
      deviceId: '',
      appImg: '',
      appUpdateUrl: ''
    }
  },
  created(){
    this.init()
  },
  methods: {
    init() {
      const query = this.$route.query
      this.appId = query.appid
      this.appVerId = query.appverid
      this.userAccount = query.useraccount
      this.deviceId = query.deviceid

      this.appImg = `${process.env.COMN_URL}app/icon/${this.appId}`

      axios({
        method: "post",
        url: process.env.COMN_URL + `app/get/${this.appId}`,
        headers: {
          "Content-Type": "application/json",
        }
      }).then(res => {
          // console.log("res", res.data.data)
          this.appNm = res.data.data.appNm
          this.appOs = res.data.data.appPlfTpNm
          if(this.appOs.toLowerCase().indexOf("android") > -1) {
            if(this.userAccount && this.deviceId){
              this.appUpdateUrl = `${process.env.COMN_URL}app/down/${this.appId}/${this.appVerId}/${this.userAccount}/${this.deviceId}`
            } else {
              this.appUpdateUrl = `${process.env.COMN_URL}app/down/${this.appId}/${this.appVerId}`
            }
          } else if (this.appOs.toLowerCase().indexOf("ios") > -1 || this.appOs.toLowerCase().indexOf("ipad") > -1) {
            if(this.userAccount && this.deviceId){
              this.appUpdateUrl = `itms-services://?action=download-manifest&url=${process.env.COMN_URL}app/plist/${this.appId}/${this.appVerId}/${this.userAccount}/${this.deviceId}`
            } else {
              this.appUpdateUrl = `itms-services://?action=download-manifest&url=${process.env.COMN_URL}app/plist/${this.appId}/${this.appVerId}`
            }
          } else {
            this.appUpdateUrl = `javascript:alert('잘못된 접근입니다.');`
          }
        })
        .catch(function (error) {
          console.log(error)
        })
    }
  }
}
</script>

<style scoped>
.app_icon{
  width: 144px;
  height: 144px;
}
</style>


// WEBPACK FOOTER //
// src/views/Update.vue